import { MouseEvent, useCallback, useEffect, useRef, useState } from "react";
import { IEvent, PostSubscribedType, SourceType } from "./enums";
import { fetchEventInformation, fetchSubscribed } from "./services";

type TrackingType = "click" | "view";

function App() {
  const [isHidden, setIsHidden] = useState<boolean>(true);
  const [event, setEvent] = useState<IEvent | null>(null);
  const [trackingType, setTrackingType] = useState<TrackingType>("view");
  const modalRef = useRef<HTMLDivElement>(null);

  const getEventData = useCallback(async () => {
    try {
      const source = document
        .getElementById("modal-event")
        ?.getAttribute("data-source") as SourceType;
      const response = await fetchEventInformation({ source: source });
      const { data } = await response.data;
      if (data && data.length > 0) {
        const eventItem = data[0];
        if (eventItem.tracking_type === "view") {
          await getSubscribed({ event_id: data[0].id }).catch((error: any) => {
            throw Error(error);
          });
        } else {
          setTrackingType(eventItem.tracking_type);
        }
        setEvent(eventItem);
        setIsHidden(false);
      } else {
        setIsHidden(true);
      }
    } catch (error) {
      setIsHidden(true);
    }
  }, []);

  useEffect(() => {
    getEventData();
  }, [getEventData]);

  const getSubscribed = async (data: PostSubscribedType) => {
    try {
      await fetchSubscribed(data);
    } catch (error: any) {
      throw Error(error);
    }
  };

  const handleCloseModal = async () => {
    try {
      await getSubscribed({
        event_id: event?.id as number,
        event_action: "button_close",
      })
        .then(() => {
          // setIsHidden(true);
          if(modalRef.current){
            removeFadeOut(modalRef.current, 1000);
          }
        })
        .catch((error: any) => {
          throw Error(error);
        });
    } catch (error) {
      // setIsHidden(true);
      if(modalRef.current){
        removeFadeOut(modalRef.current, 1000);
      }
    }
  };

  const removeFadeOut = (el: HTMLDivElement, speed: number) => {
    let seconds = speed / 1000;
    el.style.transition = "opacity " + seconds + "s ease";

    el.style.opacity = "0";
    const timeout = setTimeout(function () {
      if(el && el.parentNode){
        el.parentNode.removeChild(el);
        clearTimeout(timeout);
      }
    }, speed);
  };

  const handleClickModal = async (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (trackingType === "click") {
      await getSubscribed({
        event_id: event?.id as number,
        event_action: "body",
      })
        .then(() => {
          window.location.href = event?.event_url as string;
        })
        .catch(() => {
          setIsHidden(true);
        });
    } else {
      window.location.href = event?.event_url as string;
    }
  };

  if (isHidden || !event) {
    return null;
  }

  return (
    <div ref={modalRef} id={`event${event?.id}`} className={`modal-event`}>
      <div className="modal-event-wrapper">
        <div className="relative">
          <button
            id="iDontCareEventTopDev"
            className="btn-close-modal"
            title="Close"
            onClick={handleCloseModal}
          >
            <span className="prev-text">Đóng </span>&times;
          </button>
          <a
            id="showMeEventsPicture"
            onClick={handleClickModal}
            className="modal-link"
            href={event?.event_url}
            title={event?.description}
          >
            <img
              src={event?.image_url}
              alt={event?.title}
              className="img-fluid"
              loading="lazy"
              width={700}
              height={400}
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
